export default "/_next/static/images/background-3759f419c8b949859e719bd9dd6bbf9f.svg";